import { useState } from 'react';
import { IconButton, Box } from '@cad-arc';
import { colors } from '../../colors/colors';

export function ResultImage({ mark43FilePath }: { mark43FilePath: string }): React.ReactElement {
    const [isExpanded, setIsExpanded] = useState<boolean>(false);
    return (
        <Box
            maxWidth={isExpanded ? '280px' : '140px'}
            overflow="hidden"
            borderRadius="var(--arc-space-1)"
            marginBottom="4px"
            position="relative"
            transitionDuration="var(--arc-transition-duration-normal)"
            transitionProperty="all"
            transitionTimingFunction="var(--arc-transition-easing-east-out)"
            _after={{
                background:
                    `linear-gradient(135deg, ${colors.dexResultsImageGradientStart} 72%, ${colors.dexResultsImageGradientEnd} 100%)`,
                bottom: 0,
                content: '""',
                display: 'block',
                position: 'absolute',
                width: '100%',
                height: '100%',
            }}
        >
            <img src={mark43FilePath} alt="result" data-testid="dex-result-image" />
            <IconButton
                icon={isExpanded ? 'CollapseWindow' : 'ExpandWindow'}
                variant="ghost"
                colorVariant="white"
                onClick={() => setIsExpanded(!isExpanded)}
                aria-label={isExpanded ? 'collapse' : 'expand'}
                style={{
                    position: 'absolute',
                    right: 'var(--arc-space-2)',
                    bottom: 'var(--arc-space-2)',
                    opacity: 0.7,
                    zIndex: 'var(--arc-zIndices-docked)',
                }}
            />
        </Box>
    );
}
